export const setStateRedux = (prevState, newState) => {
    return  {
            ...prevState,
            ...newState
            }
}